/* ==========================================================================
   Size chart modal — behaviour
   Self-contained. Exits quietly if its markup is absent.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return '₹' + Math.round(cents / 100);
    }
  }

  function init(root) {
    var overlay = $('[data-ppsc-overlay]', root);
    if (!overlay) return;

    var dialog   = $('.ppsc__dialog', overlay);
    var atc      = $('[data-ppsc-atc]', root);
    var atcText  = $('[data-ppsc-atc-text]', root);
    var errorEl  = $('[data-ppsc-error]', root);
    var priceEl  = $('[data-ppsc-price]', root);

    var variants = [];
    try { variants = JSON.parse($('[data-ppsc-variants]', root).textContent) || []; } catch (e) {}

    var sizeIndex = parseInt(root.getAttribute('data-size-option-index'), 10);
    var afterAdd  = root.getAttribute('data-after-add') || 'close';
    var selectTxt = root.getAttribute('data-select-text') || 'Select a size';
    var addedTxt  = root.getAttribute('data-added-text') || 'Added';
    var addTxt    = root.getAttribute('data-add-text') || 'Add to cart';

    var chosenSize = null;
    var lastFocus = null;

    /* ---- availability per size ---- */

    function norm(s) {
      return String(s === null || s === undefined ? '' : s).trim().toLowerCase();
    }

    /* Last-resort detection: if the option name never matched, work out which
       option position actually holds the sizes by comparing the chart's own
       row labels against each option's values. */
    function detectSizeIndex() {
      if (!variants.length) return -1;
      var rowSizes = $$('[data-ppsc-row]', root).map(function (r) {
        return norm(r.getAttribute('data-size'));
      });
      if (!rowSizes.length) return -1;

      var optionCount = (variants[0].options || []).length;
      var best = -1, bestScore = 0;

      for (var i = 0; i < optionCount; i++) {
        var values = {};
        variants.forEach(function (v) { values[norm(v.options[i])] = true; });
        var score = rowSizes.filter(function (s) { return values[s]; }).length;
        if (score > bestScore) { bestScore = score; best = i; }
      }
      return bestScore > 0 ? best : -1;
    }

    function variantsForSize(size) {
      if (sizeIndex < 0) return [];
      var want = norm(size);
      return variants.filter(function (v) { return norm(v.options[sizeIndex]) === want; });
    }

    function variantForSize(size) {
      if (sizeIndex < 0) return variants[0] || null;
      var matches = variantsForSize(size);
      if (!matches.length) return null;
      var available = matches.filter(function (v) { return v.available; });
      return available[0] || matches[0];
    }

    function markAvailability() {
      var hideMissing = root.getAttribute('data-hide-missing') === 'true' && sizeIndex >= 0;

      $$('[data-ppsc-panel]', root).forEach(function (panel) {
        var rows = $$('[data-ppsc-row]', panel);
        var shown = 0;

        rows.forEach(function (row) {
          var size = row.getAttribute('data-size');
          var exists = sizeIndex < 0 || variantsForSize(size).length > 0;

          /* A size this product was never made in is hidden outright.
             A size that exists but is sold out stays, struck through. */
          if (hideMissing && !exists) {
            row.hidden = true;
            return;
          }
          row.hidden = false;
          shown++;

          var v = variantForSize(size);
          var out = !v || !v.available;
          row.classList.toggle('ppsc__row--out', out);
          row.setAttribute('aria-disabled', out ? 'true' : 'false');
        });

        /* Never leave an empty table — if nothing matched, show the lot. */
        if (shown === 0) {
          rows.forEach(function (row) {
            row.hidden = false;
            var v = variantForSize(row.getAttribute('data-size'));
            var out = !v || !v.available;
            row.classList.toggle('ppsc__row--out', out);
          });
        }
      });
    }

    /* ---- unit conversion ---- */

    function setUnit(unit) {
      $$('[data-ppsc-unit]', root).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ppsc-unit') === unit ? 'true' : 'false');
      });

      $$('[data-ppsc-panel]', root).forEach(function (panel) {
        var base = panel.getAttribute('data-ppsc-base') === 'cm' ? 'cm' : 'in';

        $$('[data-ppsc-val]', panel).forEach(function (td) {
          var raw = td.getAttribute('data-ppsc-val');
          var n = parseFloat(raw);
          if (isNaN(n)) { td.textContent = raw; return; }

          if (unit === base) {
            td.textContent = raw;                       // show exactly what was typed
          } else if (unit === 'in') {
            td.textContent = (n / 2.54).toFixed(1);     // stored cm → inches
          } else {
            td.textContent = (n * 2.54).toFixed(1);     // stored inches → cm
          }
        });
      });
    }

    /* ---- selection ---- */

    function selectSize(size) {
      chosenSize = size;
      $$('[data-ppsc-row]', root).forEach(function (r) {
        r.setAttribute('aria-checked', norm(r.getAttribute('data-size')) === norm(size) ? 'true' : 'false');
      });

      var v = variantForSize(size);
      if (atc) {
        atc.disabled = !v || !v.available;
        if (atcText) atcText.textContent = v && v.available ? addTxt : selectTxt;
      }
      if (priceEl && v) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = '<del>' + money(v.compare_at_price) + '</del><ins>' + money(v.price) + '</ins>';
        } else {
          priceEl.innerHTML = '<span>' + money(v.price) + '</span>';
        }
      }
      if (errorEl) errorEl.hidden = true;
    }

    /* ---- open / close ---- */

    /* ---- Anything painting on top of the popup --------------------------
       Class names vary by theme and app, so rather than guess we ask the
       browser what is actually drawn above the overlay at the edges of the
       screen, and hide exactly that. */

    function hideBySelector() {
      var sel = (root.getAttribute('data-hide-while-open') || '').trim();
      if (!sel) return;
      var els = [];
      try { els = Array.prototype.slice.call(document.querySelectorAll(sel)); } catch (err) { return; }
      els.forEach(function (el) {
        if (root.contains(el)) return;
        /* Never hide something large enough to be page structure — a loose
           selector must not be able to blank the site. */
        if (el === document.body || el === document.documentElement) return;
        var r = el.getBoundingClientRect();
        if (r.width > window.innerWidth * 0.9 && r.height > window.innerHeight * 0.5) return;
        el.setAttribute('data-ppsc-hidden', '');
      });
    }

    /* The June 9 sticky bar sits at the top of the stacking order on purpose,
       so instead of out-bidding it we use its own hide class — which slides
       it away neatly rather than blinking it out. */
    function toggleStickyBar(hide) {
      Array.prototype.forEach.call(document.querySelectorAll('.j9ab'), function (bar) {
        if (hide) {
          if (!bar.classList.contains('j9ab--hidden')) {
            bar.classList.add('j9ab--hidden');
            bar.setAttribute('data-ppsc-restored-by-us', '');
          }
        } else if (bar.hasAttribute('data-ppsc-restored-by-us')) {
          /* Only un-hide bars we hid — never one the bar hid itself. */
          bar.classList.remove('j9ab--hidden');
          bar.removeAttribute('data-ppsc-restored-by-us');
        }
      });
    }

    function hideOverlapping(on) {
      if (!on) {
        toggleStickyBar(false);
        $$('[data-ppsc-hidden]').forEach(function (el) {
          el.removeAttribute('data-ppsc-hidden');
        });
        return;
      }

      toggleStickyBar(true);
      hideBySelector();
    }

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      /* next frame so the transition runs */
      requestAnimationFrame(function () { overlay.classList.add('ppsc-is-open'); });
      document.body.classList.add('ppsc-locked');
      hideOverlapping(true);
      markAvailability();
      var closeBtn = $('[data-ppsc-close]', root);
      if (closeBtn) closeBtn.focus();
    }

    function close(onDone) {
      overlay.classList.remove('ppsc-is-open');
      document.body.classList.remove('ppsc-locked');
      hideOverlapping(false);
      setTimeout(function () {
        overlay.hidden = true;
        /* Only once this overlay is fully out of the way do we hand over,
           so nothing can ever sit on top of the cart drawer. */
        if (typeof onDone === 'function') onDone();
      }, 280);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* Mirrors the sequence the June 9 sticky bar already uses successfully:
       rebuild the cart, announce the added item, then — only if the drawer
       has not opened by itself — click the cart trigger. */
    function openCartDrawer(item) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: item || null }
      }));

      setTimeout(function () {
        var h = document.documentElement;
        var b = document.body;
        var alreadyOpen =
          h.classList.contains('js-drawer-open') ||
          b.classList.contains('js-drawer-open') ||
          h.classList.contains('js-drawer-open-right') ||
          b.classList.contains('js-drawer-open-right') ||
          document.querySelector('.drawer--is-open');

        if (alreadyOpen) return;

        var sel = (root.getAttribute('data-drawer-selector') || '').trim();
        var toggle = null;
        if (sel) {
          try { toggle = document.querySelector(sel); } catch (err) { toggle = null; }
        }
        if (toggle && !root.contains(toggle)) {
          toggle.click();
        }
        /* Deliberately no redirect to /cart here — a customer who opened the
           size chart to browse should not be thrown off the product page if
           the drawer cannot be found. */
      }, 450);
    }

    /* ---- cart ---- */

    function addToCart() {
      var v = variantForSize(chosenSize);
      if (!v) return;

      var original = atcText ? atcText.textContent : '';
      atc.disabled = true;
      if (atcText) atcText.textContent = '…';
      if (errorEl) errorEl.hidden = true;

      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function (json) {
          var addedItem = (json && json.items) ? json.items[0] : json;
          if (atcText) atcText.textContent = addedTxt;
          document.dispatchEvent(new CustomEvent('pp:cart:added', { bubbles: true }));

          if (afterAdd === 'cart') {
            window.location.href = base + 'cart';
            return;
          }

          function resetButton() {
            if (atcText) atcText.textContent = original || addTxt;
            atc.disabled = false;
          }

          if (afterAdd === 'drawer') {
            /* Close fully, then open the drawer — never both on screen. */
            setTimeout(function () {
              close(function () {
                openCartDrawer(addedItem);
                resetButton();
              });
            }, 450);
            return;
          }

          if (afterAdd === 'close') {
            setTimeout(function () { close(resetButton); }, 700);
            return;
          }

          setTimeout(resetButton, 1600);
        })
        .catch(function (err) {
          atc.disabled = false;
          if (atcText) atcText.textContent = original || addTxt;
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
    }

    /* ---- wiring ---- */

    root.addEventListener('click', function (e) {
      var row = e.target.closest('[data-ppsc-row]');
      if (row && root.contains(row)) {
        if (row.classList.contains('ppsc__row--out')) return;
        selectSize(row.getAttribute('data-size'));
        return;
      }

      var unit = e.target.closest('[data-ppsc-unit]');
      if (unit) { setUnit(unit.getAttribute('data-ppsc-unit')); return; }

      var tab = e.target.closest('[data-ppsc-tab]');
      if (tab) {
        var id = tab.getAttribute('data-ppsc-tab');
        $$('[data-ppsc-tab]', root).forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        $$('[data-ppsc-panel]', root).forEach(function (p) {
          p.hidden = p.getAttribute('data-ppsc-panel') !== id;
        });
        return;
      }

      if (e.target.closest('[data-ppsc-close]')) { close(); return; }
      if (e.target.closest('[data-ppsc-atc]')) { addToCart(); return; }
    });

    /* keyboard support on rows */
    root.addEventListener('keydown', function (e) {
      var row = e.target.closest('[data-ppsc-row]');
      if (row && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        if (!row.classList.contains('ppsc__row--out')) selectSize(row.getAttribute('data-size'));
      }
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('ppsc-is-open')) close();
    });

    /* ---- Triggers --------------------------------------------------------
       Capture phase so this runs before the theme's own size-chart handler,
       which would otherwise open its modal as well. */

    var pageUrl = (root.getAttribute('data-trigger-page') || '').trim();
    var extraSel = (root.getAttribute('data-trigger-selector') || '').trim();
    var triggerText = (root.getAttribute('data-trigger-text') || '').trim().toLowerCase();
    var textPhrases = triggerText ? triggerText.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];

    var selectors = ['[data-ppsc-open]', 'a[href="#size-chart"]', 'a[href$="#size-chart"]'];
    if (extraSel) {
      extraSel.split(',').forEach(function (s) {
        s = s.trim();
        if (s) selectors.push(s);
      });
    }
    var selector = selectors.join(', ');

    function isTrigger(el) {
      var match = null;
      try { match = el.closest(selector); } catch (err) { match = el.closest('[data-ppsc-open]'); }
      if (match) return true;

      /* A link pointing at the size chart page chosen in the theme editor */
      if (pageUrl) {
        var link = el.closest('a[href]');
        if (link) {
          var href = link.getAttribute('href') || '';
          if (href === pageUrl || href.indexOf(pageUrl) === 0 || href.indexOf(pageUrl + '?') > -1) return true;
        }
      }

      /* Anything labelled "Size chart" / "Size guide", whatever the theme
         called its classes. This is what catches the link your theme
         already renders. */
      if (textPhrases.length) {
        /* Themes build this link in different ways. Impulse uses a
           <tool-tip-trigger> custom element, not a link or a button. */
        var clickable = el.closest('a, button, [role="button"], tool-tip-trigger, [class*="size-chart"], [class*="size_chart"]');
        if (clickable && !root.contains(clickable)) {
          var label = (clickable.textContent || '').trim().toLowerCase();
          if (label && label.length < 40) {
            for (var i = 0; i < textPhrases.length; i++) {
              if (label.indexOf(textPhrases[i]) > -1) return true;
            }
          }
        }
      }

      return false;
    }

    document.addEventListener('click', function (e) {
      if (!isTrigger(e.target)) return;
      /* preventDefault also stops a surrounding <label> from toggling its
         radio when the trigger sits inside the variant label. */
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
    }, true);

    /* Keyboard support for triggers that are not real buttons */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!isTrigger(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);

    /* Keep the price in step with the main product form, if present */
    document.addEventListener('pp:variant:change', function (e) {
      if (!e.detail || !e.detail.variant || sizeIndex < 0) return;
      var s = e.detail.variant.options[sizeIndex];
      if (s) selectSize(s);
    });

    /* If the option name did not match, work the index out from the data. */
    if (sizeIndex < 0) sizeIndex = detectSizeIndex();

    /* Open in whichever unit the visible chart was typed in, so the first
       thing a customer sees is exactly what you entered. */
    var firstPanel = $('[data-ppsc-panel]:not([hidden])', root) || $('[data-ppsc-panel]', root);
    setUnit(firstPanel && firstPanel.getAttribute('data-ppsc-base') === 'cm' ? 'cm' : 'in');
    markAvailability();
  }

  function boot(scope) {
    $$('[data-ppsc-root]', scope).forEach(function (root) {
      if (root.dataset.ppscReady === '1') return;
      root.dataset.ppscReady = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target || document;
    $$('[data-ppsc-root]', t).forEach(function (el) { el.dataset.ppscReady = ''; });
    boot(t);
  });
})();